import { CasesView } from "@/Pages/Cases/CasesView";
import type { ComparisonFilter, DateRangeFilter, Filter } from "@/Pages/Cases/filtering/filters/CaseFilter";
import { subDays } from "date-fns";
import { CaseFilterGroup } from "@/Pages/Cases/filtering/CaseFilterGroup";

export const casesViewToFilter = (casesView: CasesView): Filter => {
  return { ...getFilter(casesView), group: CaseFilterGroup.byView };
};

const getFilter = (casesView: CasesView): Filter => {
  switch (casesView) {
    case CasesView.AllRecentCases:
      return { fieldName: "createdAt", from: subDays(new Date(), 1).toISOString() } as DateRangeFilter;
    case CasesView.NextArriving:
      return { fieldName: "markedArrivedAt", value: undefined } as ComparisonFilter;
    case CasesView.Arrived:
      return { fieldName: "markedArrivedAt", value: undefined, negative: true } as ComparisonFilter;
    case CasesView.Archived:
      return { fieldName: "createdAt", to: subDays(new Date(), 1).toISOString() } as DateRangeFilter;
  }
};
